module.exports = __webpack_public_path__ + "img/lyon.e5653628.png";